import { gql } from '@apollo/client';

export const GET_SELECTED_PROCESS_AREAS_IT_APPS = gql`
  query GetSelectedProcessAreaItApplications($data: ID!) {
    getSelectedProcessAreaItApplications(data: $data) {
      uuid
      application
      applicationType
      comment
      description
      supportsRevenue
    }
  }
`;

export const SELECT_PROCESS_AREAS_IT_APPS = gql`
  mutation SelectProcessAreaItApplications(
    $data: SelectLocationsItApplicationsInput!
  ) {
    selectProcessAreaItApplications(data: $data)
  }
`;

export const FETCH_PROCESS_AREAS_IT_APP_DASHBOARD = gql`
  query GetProcessAreaItApllicationsDashboard(
    $data: ID!
    $processAreaUUID: ID
  ) {
    getProcessAreaItApllicationsDashboard(
      data: $data
      processAreaUUID: $processAreaUUID
    ) {
      locations {
        applications {
          description
          name
          selected
          uuid
        }
        name
        processAreas {
          applications {
            description
            name
            selected
            uuid
          }
          name
          processes {
            applications {
              description
              name
              selected
              uuid
            }
            name
            revenue
            uuid
          }
          revenue
          uuid
        }
        revenue
        uuid
      }
    }
  }
`;

export const SET_PROCESS_AREAS_DEPENDENCY_VALUES = gql`
  mutation SetProcessAreaDependencyPercentage(
    $data: SetProcessAreasDependencyDataInput!
  ) {
    setProcessAreaDependencyPercentage(data: $data)
  }
`;

export const FETCH_PROCESS_AREAS_IT_APP_SUMMARY = gql`
  query GetProcessAreaItApplicationsSummary($data: ID!, $processAreaUUID: ID) {
    getProcessAreaItApplicationsSummary(data: $data, processAreaUUID: $processAreaUUID) {
      maxPercentage
      maxRevenue
      minPercentage
      minRevenue
      name
      processAreas {
        itApplicationUuid
        description
        name
        percentage
        processes {
          itApplicationUuid
          description
          name
          percentage
          revenue
          uuid
        }
        revenue
        uuid
      }
      processAreasCount
      processesCount
      uuid
    }
  }
`;

export const GET_PROCESS_AREAS_DASHBOARD = gql`
  query GetProcessAreaDashboard($locationUUID: String!) {
    getProcessAreaDashboard(locationUUID: $locationUUID) {
      applicationsTagged
      revenueSupported
      processArea
      supportedByITApplication
      uuid
    }
  }
`;

export const UPDATE_PROCESS_AREA = gql`
  mutation UpdateProcessArea($data: UpdateProcessAreaInput!) {
    updateProcessArea(data: $data) {
      uuid
    }
  }
`;

export const GET_PROCESS_AREA = gql`
  query FindProcessAreaByUuid($uuid: String!) {
    findProcessAreaByUuid(uuid: $uuid) {
      uuid
      processArea
    }
  }
`;

export const GET_PROCESS_AREA_SELECTED_IT_APPS = gql`
  query GetProcessAreasSelectedITApplications($processAreaUUID: String!) {
    getProcessAreasSelectedITApplications(processAreaUUID: $processAreaUUID) {
      itApplications {
        uuid
        application
        applicationType
        mappingComment
      }
      uuid
    }
  }
`;

export const SET_IT_APPLICATIONS_TO_PROCESS_AREAS = gql`
  mutation SetItApplicationsToProcessArea($data: ProcessAreasMappingInput!) {
    setItApplicationsToProcessArea(data: $data)
  }
`;
